import { render, staticRenderFns } from "./SecaoAtividadeFisicaMobilidade.vue?vue&type=template&id=13e062ab&scoped=true"
import script from "./SecaoAtividadeFisicaMobilidade.vue?vue&type=script&lang=js"
export * from "./SecaoAtividadeFisicaMobilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e062ab",
  null
  
)

export default component.exports